import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import EmailIcon from '../../assets/Message 36.svg';
import {
  BorderClear,
  Margin,
  Opacity,
  Padding,
  WidthFull,
} from '@mui/icons-material';

const CustomInputField = styled(TextField)(({ theme }) => ({
  height: '60px',
  backgroundColor: '#333', // Dark background
  color: 'white', // white text
  paddingLeft: '12px',
  borderColor: '#365F91',
  border: '1.4px solid transparent',
  background: `
    linear-gradient(black, black) padding-box,
    linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box
  `,
  borderImageSlice: 1,
  borderRadius: '35px',
  '& .MuiInputBase-input': {
    color: 'white', // Ensure text is white inside input
    marginLeft: '8px',
  },
  '& .MuiInputLabel-root': {
    color: '#7D7D7D', // Label color
    left: '46.5px',
    marginLeft: '20.1px',
    transform: 'translate(0, +23px)', // Position the label beside the icon
  },
  '& .MuiInputLabel-shrink': {
    left: '46.5px', // Move label to top on focus
    color: '#7D7D7D',
    marginLeft: '20.1px',
    fontSize: '12px',
    transform: 'translate(0, -1px)',
    paddingTop: '8px', // Adjust position when focused
  },

  '& .MuiInputLabel-outlined.Mui-focused': {
    color: 'white', // Color of label when focused
  },
  '& .MuiFilledInput-root': {
    '&:before': {
      borderBottom: 'none', // Remove default underline
    },
    '&:after': {
      borderBottom: 'none', // Remove focus underline
    },
    '&.Mui-focused:after': {
      color: '#7D7D7D',
      borderBottom: 'none', // Disable blue focus underline
    },
  },
  // Style for the placeholder when input is not focused
  '& .MuiInputBase-input::placeholder': {
    color: '#7D7D7D', // Placeholder text color
    opacity: 1,
  },

  // Vendor prefixes for consistent placeholder color across browsers
  '& .MuiInputBase-input::-webkit-input-placeholder': {
    paddingLeft: '0 !important', // Remove padding that pushes the text to the right
    marginLeft: '0 !important', // Ensure text starts from the left edge, including over the icon
    color: '#7D7D7D', // WebKit browsers (Chrome, Safari)
  },
  '& .MuiInputBase-input::-moz-placeholder': {
    color: '#7D7D7D', // Firefox
  },
  '& .MuiInputBase-input:-ms-input-placeholder': {
    color: '#7D7D7D', // Internet Explorer
  },
  '& .MuiInputBase-input::-ms-input-placeholder': {
    color: '#7D7D7D', // Edge
  },
  // Ensure the placeholder color remains the same when focused
  '& .MuiInputBase-input:focus::placeholder': {
    color: '#7D7D7D', // Same placeholder color when focused
    opacity: 1,
  },
}));

interface EmailInputProps {
  value: string;
  type: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  placeholder: string;
  autoComplete?: string;
}

const EmailInput: React.FC<EmailInputProps> = ({
  type,
  value,
  onChange,
  label,
  ...props
}) => {
  return (
    <CustomInputField
      value={value}
      type={type}
      label={label}
      variant="filled"
      onChange={onChange}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mb: 0.5 }}>
            <img src={EmailIcon} alt="email icon" />
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: !!value, // Control shrink based on value
      }}
      {...props}
    />
  );
};

export default EmailInput;
